<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/exfAqJ/tc-custom/9780312870973.jpg?1732050404866" alt="This image is the cover for the book Bowie"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bowie
      </h1>
      <p class="bookDescription body article font2">
        <p>Jim Bowie, the descendant of Highland Scots, grew up riding alligators and working the field on the Texas frontier. Taught three languages and a sense of honor, he went on to live a life filled with brawls and battles, loves and loses. This is his story, as told by those who, whether they loved or hated him, were united by their awe of this amazing frontiersman.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Randy Lee Eickhoff, Leonard C. Lewis
      </h2>
      
      <p class="authorDescription body article"><P><B>Randy Lee Eickhoff</B> holds several graduate degrees, including a Ph.D. in Classics. He lives in El Paso, Texas where he works on translations in several languages, poetry, plays, and novels of which two have been nominated for the Pulitzer Prize. His translation of Ireland's national epic is now a text in not only schools in the United States, but countries overseas as well. His nonfiction work on the Tigua Indians, Exiled, won the Southwest History Award. He has been inducted into the Paso Del Norte Writers Hall of Fame, the local chapter of the Texas Institute of Arts and Letters. He spends his time in El Paso, Ireland, and Italy, lecturing on Dante and The Ulster Cycle.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43e9ce6c